// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__gfFUw","col":"styles_col__1-5WJ","fulfillmentStatus":"styles_fulfillmentStatus__21qBL","emailCol":"styles_emailCol__EwREk"};